// Thank-you email attribution token (rebook link lands on /?src=ty#ty=<token>).
//
// Held in module memory ONLY: no sessionStorage, localStorage or cookies, because
// browser storage for attribution is terminal-equipment access (Art. 5(3) ePrivacy,
// §25 TDDDG). A reload loses the token on purpose.

export const THANK_YOU_TOKEN_RE = /^[A-Za-z0-9_-]{32}$/

let token = null

export const isValidThankYouToken = (value) =>
    typeof value === 'string' && THANK_YOU_TOKEN_RE.test(value)

// Stores the token when it has the expected shape; anything else clears it.
export const setToken = (value) => {
    token = isValidThankYouToken(value) ? value : null
    return token
}

export const getToken = () => token

export const clearToken = () => {
    token = null
}
